import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class AuthService {
  private readonly authBaseApiUrl: string;

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.authBaseApiUrl = `${baseUrl}api/authorization`;
  }
  
}
